<div class="update-sheet">
  <div class="update-sheet__icon-wrap">
    <img src="assets/icon/happening-logo.png" alt="HappeningPh" class="update-sheet__app-icon" />
    <div class="update-sheet__badge">
      <ion-icon name="arrow-up-circle-outline"></ion-icon>
    </div>
  </div>

  <h2 class="update-sheet__title">Update Required</h2>

  <p class="update-sheet__message">
    A new version of HappeningPh is available. Please update to continue using the app.
  </p>

  <ion-button
    expand="block"
    class="update-sheet__cta"
    (click)="openStore()"
  >
    Update Now
  </ion-button>

  <p class="update-sheet__hint">You must update to continue.</p>
</div>
